<div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" class="logo">
  <div fxFlex="10" fxFlex.md="20" fxFlex.sm="100" fxFlex.xs="100" fxFlexAlign="start" fxFlexAlign.lt-md="center">
    <div fxHide.gt-sm="true" class="mobile-toolbar-button">
      <button mat-icon-button *ngIf="!mobileToolbarOpen" (click)="mobileToolbarOpen = true">
        <mat-icon>menu</mat-icon>
      </button>
      <button mat-icon-button *ngIf="mobileToolbarOpen" (click)="mobileToolbarOpen = false">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <img routerLink="/" src="assets/img/KeyFigures_Logo.svg" alt="logo">
  </div>
  <div fxFlex="90" fxFlex.md="80" fxFlex.sm="100" fxFlex.xs="100">
    <mat-toolbar color="primary" fxHide.lt-md="true">
      <mat-toolbar-row class="toolbar-menu">
        <div *ngFor="let item of menuItemsByRole" class="menu-item">
          <a mat-button (mouseover)="onMouseOver(item)">
            {{item.title}}
          </a>
        </div>
        <span class="spacer"></span>
        <a mat-raised-button [matMenuTriggerFor]="menu">
          <div class="username">
            <span [class]="system !== null || country !== null ? 'name' : ''">{{userName}}</span>
            <span>{{system !== null && country !== null ? system + ' / '+ country : (system !== null ? system : country) }}</span>
          </div>
          <mat-icon>arrow_drop_down</mat-icon>
        </a>
        <mat-menu #menu="matMenu">
          <a mat-menu-item (click)="changePassord()">Change password</a>
          <a mat-menu-item (click)="doLogout()">Logout</a>
        </mat-menu>
      </mat-toolbar-row>
      <mat-toolbar-row *ngIf="toolbarMenuVisible" (mouseleave)="onMouseOut()" class="toolbar-submenu">
        <div class="toolbar-divider"></div>
        <div *ngFor="let item of submenus">
          <a mat-button (click)="loadLateralMenu(item)">
            {{item.title}}
          </a>
        </div>
      </mat-toolbar-row>
    </mat-toolbar>
  </div>
  <!-- Mobile toolbar -->
  <div fxHide.gt-sm="true" *ngIf="mobileToolbarOpen">
    <mat-toolbar color="primary">
      <mat-list>
        <div *ngFor="let item of menuItemsByRole">
          <mat-list-item>
            <mat-toolbar-row class="mobile-toolbar-row" (click)="submenusMenu.hidden = !submenusMenu.hidden;onMobileMenuSelected(item)">
              <span>{{item.title}}</span>
              <span class="spacer"></span>
              <mat-icon *ngIf="submenusMenu.hidden" class="toolbar-icon">chevron_right</mat-icon>
              <mat-icon *ngIf="!submenusMenu.hidden" class="toolbar-icon">expand_more</mat-icon>
            </mat-toolbar-row>
          </mat-list-item>
          <div #submenusMenu hidden class="mobile-toolbar-submenu">
            <div *ngFor="let submenu of item?.submenus">
              <a mat-button (click)="mobileToolbarOpen = false;loadLateralMenu(submenu)">
                {{submenu.title}}
              </a>
            </div>
          </div>
          <mat-divider></mat-divider>
        </div>
      </mat-list>
    </mat-toolbar>
  </div>
</div>

